'use client';

import { useEffect } from 'react';

/**
 * Appends a Google Fonts stylesheet after mount, so the CJK font loads without
 * blocking render (equivalent to the old `next/font/google` `preload: false`).
 * Done at runtime on purpose: `next/font/google` fetches at build time and a
 * failed fetch is fatal under Turbopack.
 */
export default function CjkFontStylesheet({ href }: { href: string }) {
  useEffect(() => {
    // Match on rel too: the server layout preloads the same href (rel="preload").
    if (document.head.querySelector(`link[rel="stylesheet"][href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }, [href]);
  return null;
}
